import type { IAdditionalSettings } from '@/interfaces/agency/settings/agency/additional-settings';

const AGENCY_ADDITIONAL_SETTINGS_KEY = 'agencyAdditionalSettings';

export function useDefaultRecordsPerPage() {
  const parseDefaultRecordsPerPage = (settings: IAdditionalSettings[]): number => {
    const setting = settings.find(s => s.key === 'default_records_per_page');
    if (!setting?.value?.key) return 10;
    const val = setting.value.key;
    const num = typeof val === 'number' ? val : Number(val);

    return Number.isFinite(num) ? num : 10;
  };

  const getDefaultRecordsPerPageFromStorage = (): number => {
    const settings: IAdditionalSettings[] = JSON.parse(localStorage.getItem(AGENCY_ADDITIONAL_SETTINGS_KEY) || '[]');

    return parseDefaultRecordsPerPage(settings);
  };

  return {
    AGENCY_ADDITIONAL_SETTINGS_KEY,
    parseDefaultRecordsPerPage,
    getDefaultRecordsPerPageFromStorage
  };
}
